<template>
  <div>
    <v-tooltip open-delay="500" top>
      <template #activator="{ on, attrs }">
        <v-btn :disabled="disabled" x-small icon v-bind="attrs" v-on="on" @click.stop="mudarEstadoDialog">
          <v-icon small v-text="'mdi-information-outline'" />
        </v-btn>
      </template>
      <span>Detalhamento das últimas compras</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog_ativo"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title class="text-white px-2" style="background: #042333;">
          <v-btn icon dark class="mr-5">
            <v-icon @click.stop="mudarEstadoDialog">mdi-close</v-icon>
          </v-btn>

          <span>Últimas compras</span>
        </v-card-title>

        <v-card-text class="px-0 py-0">
          <slot name="topo-corpo" />

          <v-tabs v-model="data_referencia" background-color="#f8f7f7" show-arrows class="mt-n1">
            <v-tab v-for="mes in ULTIMOS_12_MESES" :key="mes.data_referencia" :href="`#${mes.data_referencia}`">
              {{ mes.descricao }}
            </v-tab>
          </v-tabs>

          <v-data-table
            height="calc(100vh - 210px)"
            :headers="headers"
            :items="vendas_mes_selecionado"
            class="ml-2"
            :items-per-page="-1"
            fixed-header
          >
            <template #item.qtde="{item}">
              {{ Helpers.formatarValor(item.qtde) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {buscarUltimasVendasMensais} from "../../../../api/compraPorDepartamentos/Departamento.js";
import {logout, nomeMeses} from "../../../../helpers";

export default {
  name: "VendasUltimosMeses",
  props: {
    filtros: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    dialog_ativo: false,
    data_referencia: null,
    data_atual: null,
    headers: [
      { text: "Produto", value: "produto" },
      { text: "Filial", value: "filial" },
      { text: "Id pedido", value: "idconsumo" },
      { text: "Data de emissao", value: "emissao" },
      { text: "Horário", value: "horariomov" },
      { text: "Quantidade", value: "qtde" },
      { text: "Preço de venda", value: "preco_venda" },
    ],
    vendas_mes_selecionado: [],
  }),
  computed: {
    ULTIMOS_12_MESES() {
      if (!this.data_atual || !this.data_atual.length) return [];

      let [_, mes, ano] = this.data_atual.split('/');
      mes = parseInt(mes);

      let meses = [];

      for (let i = 0; i < 12; i++) {
        meses.push({
          data_referencia: '01/'.concat(`${mes}`.padStart(2, 0), '/', ano),
          descricao: `${nomeMeses[mes - 1] || mes}/${ano}`,
        });

        if (mes === 1) {
          mes = 12;
          ano--;
        } else {
          mes--;
        }
      }

      return meses.reverse();
    }
  },
  watch: {
    data_atual() {
      if (!this.data_atual || !this.data_atual.length) return;

      this.data_referencia = this.data_atual;
    },
    data_referencia() {
      if (this.data_referencia !== this.data_atual) {
        this.vendas_mes_selecionado = [];
        this.buscarUltimasVendasMensais();
      }
    }
  },
  methods: {
    mudarEstadoDialog() {
      this.dialog_ativo = !this.dialog_ativo;

      if (this.dialog_ativo) {
        this.data_referencia = null;
        this.data_atual = null;
        this.vendas_mes_selecionado = [];
        this.buscarUltimasVendasMensais();
      }
    },
    buscarUltimasVendasMensais() {
      const parametros = {
        grupo: this.filtros.grupo,
        iddepartamento: this.filtros.iddepartamento,
        idsecao: this.filtros.idsecao,
        idcategoria: this.filtros.idcategoria,
        idproduto: this.filtros.idproduto,
        data_referencia: this.data_referencia
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        buscarUltimasVendasMensais(parametros)
          .then(resp => {
            this.data_atual = resp.data_atual;
            this.vendas_mes_selecionado = resp.vendas_mes;
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>
</style>
